export enum AdminRequisitesType {
  bank = "bank",
  crypto = "crypto",
}
